/**
 * Defensive client-side bound for alert reads.
 *
 * Every alert query already sends `start_time`/`end_time`, but the `/map` feed
 * is polled live and was still surfacing alerts far older than the selected
 * window, so the wire filter cannot be the only guard.
 *
 * Time basis: alert `timestamp`s are true UTC instants (ISO with `Z`) and the
 * range's `Date`s are true UTC instants too, so both sides are compared as
 * epoch milliseconds. The org/location timezone (`shared/utils/date/org-time.ts`)
 * is DISPLAY-only and must never enter this comparison.
 *
 * Bounds are inclusive on both ends, matching the request params. An alert whose
 * timestamp cannot be parsed cannot be shown to fall inside the window, so it is
 * dropped rather than let through.
 */
export const isAlertWithinRange = (
  alert: { timestamp: string },
  fromDate: Date,
  toDate: Date,
): boolean => {
  const at = new Date(alert.timestamp).getTime();
  return Number.isFinite(at) && at >= fromDate.getTime() && at <= toDate.getTime();
};
